import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatCounterComponent } from './chat-counter.component';

@NgModule({
  declarations: [ChatCounterComponent],
  imports: [CommonModule],
  exports: [ChatCounterComponent],
})
export class ChatCounterModule {}
